<template>
	<div class="grid p-fluid">
        <Toast/>
        <!-- Aviso fijo mientras Contablus espera al SRI (ver service/sriPendingToast.js) -->
        <Toast group="sriPending"/>
        <div class="col-12">
			<div class="card" :style="{'background-color':this.cardBackgroundColor}">
                <div style="width: 100%; display: flex;">
                    <h2 style="font-size: large;">Guía de Remisión - {{ this.$store.getters.defaultActivity.name }}</h2>
                </div>
                <div class="grid formgrid" style="margin-top: 0px;" v-show="this.sale.id !== null">
                    <div class="col-12">
                        <div class="card">
                            <h5 style="margin-bottom: 25px;"><b>{{ this.documentType }} {{ (this.sale.id !== null) ? " N: " + this.sale.serialNumber : this.guide.saleSerialNumber }}</b></h5>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-6">
                                    <div style="display: flex;">
                                        <label style="font-weight: bold; text-align: left;">Cliente:</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.name : "CONSUMIDOR FINAL" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Céd/RUC/Pasaporte:</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.identification : "9999999999" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Dirección</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.address : "-" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Correo</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.email !== null) ? this.sale.customer.email : "-" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Teléfono</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.phone : "9999999999" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Fecha Emisión</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.id !== null) ? this.sale.createdAt.toLocaleDateString("es-ES") : "" }}</label>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-6 saleInformationContainer">
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal 0%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub0 ? this.sale.sub0.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal 12%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub12 ? this.sale.sub12.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal sin impuestos</label>
                                        <label style="margin: 0px 0px 0px auto;">
                                            {{
                                                (this.sale.sub0 && this.sale.sub12)
                                                    ? this.sale.sub0.plus(this.sale.sub12).toFixed(2)
                                                    : (this.sale.sub0 ? this.sale.sub0.toFixed(2) : (this.sale.sub12 ? this.sale.sub12.toFixed(2) : '0.00'))
                                            }}
                                        </label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">IVA (12%)</label>
                                        <label style="margin: 0px 0px 0px auto;">
                                            {{ this.sale.sub12 ? this.sale.sub12.times(0.12).toFixed(2) : '0.00' }}
                                        </label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Descuento</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.discount ? this.sale.discount.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Total</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.total ? this.sale.total.toFixed(2) : '0.00' }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5><b>Producto(s)</b></h5>
                            <Button icon="pi pi-plus" v-if="this.guide.id === null" class="p-button-rounded p-button-success mr-2 mb-2" style="position: absolute; top: 15px; right: 20px;" @click="displayProductDialog"/>
                            <DataTable :value="this.guide.items" editMode="cell" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                <Column field="amount" header="Cantidad" :style="{width: '25%','min-width':'50px'}">
                                    <template #editor="{data, field}" v-if="this.guide.id === null">
                                        <InputText v-model="data[field]" type="number" autofocus :disabled="this.guide.id !== null" @change="onItemChanged(data)" />
                                    </template>
                                </Column>
                                <Column field="description" header="Descripción" :style="{width: '70%','min-width':'100px'}">
                                    <template #editor="{data, field}" v-if="this.guide.id === null">
                                        <InputText v-model="data[field]" type="text" autofocus :disabled="this.guide.id !== null" @change="onItemChanged(data)" />
                                    </template>
                                </Column>
                                <Column :exportable="false" :style="{width: '5%','min-width':'50px'}">
                                    <template #body="item" v-if="this.guide.id === null">
                                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"  @click="onItemDeleted(item)"/>
                                    </template>
                                </Column>
                            </DataTable>
                            <h6 class="p-invalid" v-if="this.productError" style="color: red;">Ingrese al menos un producto</h6>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5><b>Destino(s)</b></h5>
                            <Button icon="pi pi-plus" v-if="this.guide.id === null" class="p-button-rounded p-button-success mr-2 mb-2" style="position: absolute; top: 15px; right: 20px;" @click="displayDestinationDialog"/>
                            <DataTable :value="this.guide.destinations" editMode="cell" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                <Column field="receiverIdentification" header="Céd/RUC/Pas" :style="{width: '20%','min-width':'40px'}"></Column>
                                <Column field="receiverName" header="Rázon Social" :style="{width: '20%','min-width':'40px'}"></Column>
                                <Column field="address" header="Dirección" :style="{width: '20%','min-width':'40px'}"></Column>
                                <Column field="reason" header="Motivo" :style="{width: '30%','min-width':'40px'}"></Column>
                                <Column :exportable="false" style="width: 5% ;min-width: 30px;">
                                    <template #body="item" v-if="this.guide.id === null">
                                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text mr-2 mb-2"  @click="onEditDestination(item)"/>
                                    </template>
                                </Column>
                                <Column :exportable="false" style="width: 5% ;min-width: 30px;">
                                    <template #body="item" v-if="this.guide.id === null">
                                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"  @click="onDestintationDeleted(item)"/>
                                    </template>
                                </Column>
                            </DataTable>
                            <h6 class="p-invalid" v-if="this.destinationError" style="color: red;">Ingrese al menos un destino</h6>
                        </div>
                    </div>
                </div>
                
                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5 style="margin-bottom: 25px;"><b>Datos del transportista</b></h5>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-12">
                                    <div class="grid formgrid" style="width: 100%;">
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <div style="display: flex">
                                                <label for="courrierName">Nombre del transportista</label><br>
                                                <small style="color: gray; margin-left: auto;">Busque por nombre</small>
                                            </div>
                                            <AutoComplete autofocus placeholder="Nombres del transportista" v-model="this.courrier" :disabled="this.guide.id !== null" optionLabel="name" field="name" :suggestions="this.courrierSuggestions" @complete="searchCourrier($event)">
                                                <template #option="slotProps">
                                                    <div>{{ slotProps.option.name + " - " + slotProps.option.id }}</div>
                                                </template>
                                            </AutoComplete>  
                                            <small class="p-invalid" v-if="this.courrierNameError">Ingrese el nombre del transportista</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="courrierId">Cédula del transportista</label>
                                            <InputText v-model="this.courrier.id" placeholder="Id. del transportista" id="courrierId" type="text" :class="{'p-invalid': this.courrierIdentificationError}" @change="onResetFieldError($event)" :disabled="this.guide.id !== null" />
                                            <small class="p-invalid" v-if="this.courrierIdentificationError">La cédula debe tener 10 digitos</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="vehicleId">Placa del Vehículo</label>
                                            <InputText v-model="this.courrier.vehicleId" placeholder="Placa del vehículo" id="vehicleId" type="text" :class="{'p-invalid': this.vehicleIdentificationError}" @change="onResetFieldError($event)" :disabled="this.guide.id !== null" />
                                            <small class="p-invalid" v-if="this.vehicleIdentificationError">Ingrese la placa del vehículo</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5 style="margin-bottom: 25px;"><b>Lugar y fecha de partida</b></h5>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-12">
                                    <div class="grid formgrid" style="width: 100%;">
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="departureAddress">Dirección de Salida</label>
                                            <InputText v-model="this.guide.departureAddress" placeholder="Dirección" id="departureAddress" type="text" :class="{'p-invalid': this.departureAddressError}" @change="onResetFieldError($event)" :disabled="this.guide.id !== null" />
                                            <small class="p-invalid" v-if="this.departureAddressError">Ingrese la dirección de salida del vehículo</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="startDeliveryDate">Fecha de salida</label>
                                            <Calendar v-model="this.guide.startDeliveryDate" placeholder="dd/mm/yyyy" :maxDate="this.guide.endDeliveryDate" id="startDeliveryDate" :class="{'p-invalid': this.startDeliveryDateError}" @change="onResetFieldError($event)" :disabled="this.guide.id !== null"/>
                                            <small class="p-invalid" v-if="this.startDeliveryDateError">Ingrese fecha de salida del vehículo</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="endDeliveryDate">Fecha de llegada</label>
                                            <Calendar v-model="this.guide.endDeliveryDate" placeholder="dd/mm/yyyy" :minDate="this.guide.startDeliveryDate" id="endDeliveryDate" :class="{'p-invalid': this.endDeliveryDateError}" @change="onResetFieldError($event)" :disabled="this.guide.id !== null" />
                                            <small class="p-invalid" v-if="this.endDeliveryDateError">Ingrese fecha de llegada del vehículo</small>
                                        </div>
                                        <!-- Fila propia a todo lo ancho, bajo los tres campos. Antes era un
                                             contenedor `grid` (flex en fila) que ponia el label al costado
                                             y encogia el cuadro de texto. -->
                                        <div class="col-12" v-if="this.guide.id === null || this.guide.observations" style="margin-top: 1rem;">
                                            <label for="guideObservations">Observaciones</label>
                                            <ObservationsField inputId="guideObservations" :rows="3" :disabled="this.guide.id !== null" :maxLength="observationsMaxLength" v-model="this.guide.observations"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5><b>Valores de Guía de Remisión</b></h5>
                            <div class="field col-12 md:col-6">
                                <div style="margin-top: 10px;">
                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                        <label style="margin: 0px;"><b>Secuencial</b></label><br>
                                        <label style="margin: 0px; font-weight: 300;">{{ (this.guide.edoc !== null) ? this.guide.edoc.sequence : "-" }}</label>
                                    </div>
                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                        <label style="margin: 0px;"><b>Fecha Emisión</b></label><br>
                                        <label style="margin: 0px; font-weight: 300;">{{ (this.guide.edoc !== null && this.guide.edoc.sentAt !== null) ? this.guide.edoc.sentAt.toLocaleDateString("es-ES") : "-" }}</label>
                                    </div>
                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                        <label style="margin: 0px;"><b>Fecha Autorización</b></label><br>
                                        <label style="margin: 0px; font-weight: 300;">{{ (this.guide.edoc !== null && this.guide.edoc.authorizedAt !== null) ? this.guide.edoc.authorizedAt.toLocaleDateString("es-ES") : "-" }}</label>
                                    </div>
                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                        <label style="margin: 0px;"><b>Código de acceso</b></label><br>
                                        <label style="margin: 0px; font-weight: 300; max-width: 90%;">{{ (this.guide.edoc !== null) ? this.guide.edoc.accessCode : "-" }}</label>
                                    </div>
                                    <!-- Desenlace de la anulacion, no un cartel fijo: el texto y el color
                                         salen de annulmentStatus (ver models/edocument.js). Antes decia
                                         siempre "debe ser anulada en el portal del SRI" con solo mirar
                                         nulled+received, y eso mentia justo cuando el SRI aceptaba la
                                         solicitud. Lo que esta EN CURSO no sale aca. -->
                                    <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.guide.edoc !== null && this.guide.edoc.annulmentNotice !== null">
                                        <div class="flex align-items-start mt-3 p-3"
                                             :style="`background-color: var(--${this.guide.edoc.annulmentNotice.color}-50); border-left: 4px solid var(--${this.guide.edoc.annulmentNotice.color}-500); border-radius: 4px; --notice-accent: var(--${this.guide.edoc.annulmentNotice.color}-500); --notice-accent-strong: var(--${this.guide.edoc.annulmentNotice.color}-700);`">
                                            <i class="pi mr-2 mt-1" :class="this.guide.edoc.annulmentNotice.icon"
                                               :style="`color: var(--${this.guide.edoc.annulmentNotice.color}-700)`" />
                                            <div style="flex: 1; min-width: 0;">
                                                <div style="font-size: 0.9rem;">{{ this.guide.edoc.annulmentNotice.title }}</div>
                                                <div v-if="this.guide.edoc.annulmentNotice.detail"
                                                     style="font-size: 0.82rem; color: var(--text-color-secondary); margin-top: 0.15rem;">{{ this.guide.edoc.annulmentNotice.detail }}</div>
                                                <!-- La accion la declara el aviso (Reportar / Consultar estado):
                                                     el modelo decide que se puede hacer en cada estado. -->
                                                <Button v-if="this.guide.edoc.annulmentNotice.action"
                                                        :label="this.guide.edoc.annulmentNotice.action.label"
                                                        :icon="this.guide.edoc.annulmentNotice.action.icon"
                                                        class="p-button-sm annulmentNoticeAction mt-2"
                                                        :disabled="annulmentInProgress"
                                                        @click="onAnnulmentAction(this.guide.edoc.annulmentNotice.action.name)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field col-12 md:col-12 saleFormButtonContainer" style="margin-top: 15px;">
                                <Button label="Limpiar" v-show="showClearButton" class="customButton p-button-raised p-button-danger mr-2 mb-2" @click="onClearFields"/>
                                <Button label="Anular" v-show="showDeleteButton" class="customButton p-button-raised p-button-danger mr-2 mb-2" @click="displayDeleteguideConfirmation(true)"/>
                                <div style="margin-left: auto;"></div>
                                <Button label="Guardar" v-show="showSaveButton" :loading="loadingSaveButton" class="customButton p-button-raised p-button-success mr-2 mb-2" @click="saveGuide()"/>
                                <Button label="Generar" v-show="showCreateEDOCButton" :loading="loadingCreateEDOCButton" class="customButton p-button-raised p-button-success mr-2 mb-2" @click="attemptToCreateRemisionGuide()"/>
                                <Menu ref="menu" :model="downloadOptions" :popup="true" style="width: auto;">
                                    <template #item="{item}">
                                        <Button type="button" :label="item.label" :icon="item.icon" class="menuButton mr-2 mb-2" :loading="loadingDownloadGuideButton" @click="downloadGuide(item.name)"/>
                                    </template>
                                </Menu>
                                <Button type="button" label="Descargar" icon="pi pi-angle-down" v-show="showDownloadGuideButton" class="customButton p-button-raised p-button-success mr-2 mb-2" @click="toggleDownloadMenu"/>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog header="Advertencia" v-model:visible="showSubscriptionDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                    <p class="line-height-3 m-0">
                        {{ this.error.title }}<br>
                        {{ this.error.mensaje }}<br>
                        {{ this.error.informacionAdicional }}
                    </p>
                    <template #footer>
                        <Button label="Cerrar" @click="closeSubscriptionDialog" class="p-button-secondary mr-2 mb-2"/>
                        <Button label="Ver suscripción" @click="redirectToSubscription" class="p-button-info mr-2 mb-2"/>
                    </template>
                </Dialog>

                <Dialog :header="annulmentExpired ? 'No se puede anular' : 'Confirmación'" v-model:visible="showDeleteguideConfirmation" :style="{width: annulmentExpired ? '480px' : '420px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <!-- Fuera del plazo del SRI no se anula: el mensaje (y la guarda que lo
                         respalda) vienen del backend, ver EDocument.annulmentWindowClosedMessage. -->
                    <div v-if="guide.edoc && guide.edoc.annulmentExpired" class="flex align-items-start">
                        <i class="pi pi-ban mr-3" style="font-size: 2rem; color: var(--red-500)" />
                        <span>{{ guide.edoc.annulmentExpiredMessage }}</span>
                    </div>
                    <template v-else>
                        <div class="flex align-items-center justify-content-center">
                            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                            <span>¿Está seguro de anular esta guía de remisión?</span>
                        </div>
                        <!-- Como la factura: el SRI la anula en el acto, pero el viaje por el
                             portal toma su tiempo. Decirlo antes evita que parezca colgado. -->
                        <div v-if="guide.edoc && guide.edoc.authorized" class="mt-3 p-3"
                             style="background-color: var(--blue-50); border-left: 4px solid var(--blue-500); border-radius: 4px; font-size: 0.9rem;">
                            Se enviará la solicitud al SRI. Puede tardar hasta un par de
                            minutos y el resultado aparecerá en pantalla.
                        </div>
                    </template>
                    <template #footer>
                        <Button v-if="annulmentExpired" label="Entendido" @click="displayDeleteguideConfirmation(false)" class="p-button-secondary mr-2 mb-2" autofocus/>
                        <template v-else>
                            <Button label="No" @click="displayDeleteguideConfirmation(false)" class="p-button-secondary mr-2 mb-2"/>
                            <Button label="Sí" :loading="loadingDeleteButton" @click="deleteGuide()" class="p-button-warning mr-2 mb-2" autofocus />
                        </template>
                    </template>
                </Dialog>

                <!-- Sin credenciales del portal no se le puede informar la anulacion al
                     SRI (ver saleForm.vue): al ANULAR se ofrece anular sin reportar; al
                     REPORTAR una que ya quedo solo aca, el unico camino es cargarlas. -->
                <Dialog header="Credenciales del SRI no registradas" v-model:visible="showSriCredentialsDialog" :style="{width: '520px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <div class="flex align-items-start">
                        <i class="pi pi-info-circle mr-3 mt-1" style="font-size: 2rem; color: var(--blue-500)" />
                        <div v-if="annulmentUnreported">
                            <p class="mb-2">
                                Esta guía de remisión ya está anulada en Contablus, pero
                                <strong>para el SRI sigue vigente</strong>.
                            </p>
                            <p class="mb-0">
                                Registra las credenciales del portal <strong>SRI en línea</strong>
                                y Contablus se encargará de informar la anulación y de dar
                                seguimiento al estado de la solicitud.
                            </p>
                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                        <div v-else>
                            <p class="mb-2">
                                Para anular el comprobante ante el SRI de forma automática,
                                el negocio necesita tener registradas sus credenciales del
                                portal <strong>SRI en línea</strong>.
                            </p>
                            <p class="mb-0" style="font-size: 0.9rem; color: var(--orange-700);">
                                Si continúas sin reportar, la guía quedará anulada en Contablus
                                pero <strong>para el SRI seguirá vigente</strong>. Tendrás que
                                anularla desde el portal; Contablus la detectará sola.
                            </p>
                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="(annulmentUnreported && !canEditBusiness) ? 'Entendido' : 'Cancelar'" @click="showSriCredentialsDialog = false" class="p-button-secondary mr-2 mb-2"/>
                        <Button v-if="!annulmentUnreported" label="Anular sin reportar" icon="pi pi-exclamation-triangle" @click="deleteGuide(false)" class="p-button-warning mr-2 mb-2"/>
                        <Button v-if="canEditBusiness" label="Registrar credenciales" icon="pi pi-external-link" @click="goToSriCredentials" class="p-button-info mr-2 mb-2" autofocus/>
                    </template>
                </Dialog>

                <!-- Desenlace de la anulacion (ver saleForm.vue): Dialog y no toast, es
                     informacion que hay que leer. -->
                <Dialog :header="annulmentOutcome ? annulmentOutcome.title : ''"
                        v-model:visible="showAnnulmentOutcome"
                        :style="{width: '460px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <div v-if="annulmentOutcome !== null" class="flex align-items-start">
                        <i class="pi mr-3" :class="annulmentOutcome.icon"
                           :style="`font-size: 2rem; color: var(--${annulmentOutcome.color}-500)`" />
                        <div style="min-width: 0;">
                            <span style="line-height: 1.5; overflow-wrap: anywhere;">{{ annulmentOutcome.message }}</span>
                            <p v-if="annulmentOutcome.action === 'sriCredentials' && !canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Entendido" @click="showAnnulmentOutcome = false"
                                class="p-button-secondary mr-2 mb-2" autofocus />
                        <Button v-if="annulmentOutcome !== null && annulmentOutcome.action === 'sriCredentials' && canEditBusiness"
                                label="Ir a Negocio" icon="pi pi-external-link" @click="goToSriCredentials"
                                class="p-button-info mr-2 mb-2" />
                    </template>
                </Dialog>

                <Dialog v-model:visible="showProductDialog" :style="{'max-width': '600px', width: '90%'}" header="Buscar Producto" :modal="true" class="p-fluid">
                    <AutoComplete autofocus placeholder="Buscar por nombre..." id="dd" :dropdown="false" :multiple="false" v-model="searchedProduct" @complete="onProductFilterChanged($event)" inputStyle="width: 100%;" style="width: 100%; margin-top: 5px;" :selectOnFocus="true"/>
                    <DataTable :value="this.productOptions" v-model:selection="selectedProduct" selectionMode="single" @rowSelect="onProductSelected" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                        <Column field="code" header="Cód." :style="{width: '25%','min-width':'70px'}"></Column>
                        <Column field="name" header="Nombre." :style="{width: '50%','min-width':'100px'}"></Column>
                        <Column field="price" header="Precio" :style="{width: '25%','min-width':'70px'}">
                            <template #body="slotProps">
                                ${{ slotProps.data.price }}
                            </template>
                        </Column>
                    </DataTable>
                    <Divider layout="horizontal" align="center">
                            <b>O agregue un producto manualmente</b>
						</Divider>
                    <div class="grid formgrid">
                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                            <InputText ref="productAmount" type="number" v-model="this.guideItem.amount" placeholder="Cantidad" style="margin-top: 5px;"/>
                        </div>
                        <div class="col-12 mb-2 lg:col-8 lg:mb-0">
                            <InputText ref="productDescription" type="text" v-model="this.guideItem.description" placeholder="Descripción" style="margin-top: 5px;"/>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Agregar" class="p-button-success mr-2 mb-2" @click="onAddProduct"/>
                    </template>
                </Dialog>

                <Dialog v-model:visible="showDestinationDialog" :style="{'max-width': '450px', width: '90%'}" header="Agregar Destino" :modal="true" class="p-fluid">
                    <div class="grid formgrid">
                        <div class="col-12 mb-2 lg:col-12 lg:mb-0" style="margin-bottom: 1rem !important;">
                            <h5 style="margin: 2px 0px 0px 0px;">Nombre Completo del Receptor</h5>
                            <small style="color: gray; font-style: italic;">Busque un cliente existente con el nombre o razón social</small>
                            <AutoComplete
                                autofocus
                                placeholder="Nombres o Razón social"
                                v-model="this.destination"
                                optionLabel="receiverName"
                                field="receiverName"
                                :suggestions="this.destinationSuggestions"
                                @complete="searchDestination($event)"
                                :appendTo="'self'"
                            >
                                <template #option="slotProps">
                                    <div>{{ slotProps.option.receiverName + " - " + slotProps.option.receiverIdentification }}</div>
                                </template>
                            </AutoComplete>    
                        </div>
                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                            <h5 style="margin-bottom: 2px;">Céd/RUC/Pas del Receptor</h5>
                            <InputText type="text" v-model="this.destination.receiverIdentification" placeholder="Identificación" maxlength="20" style="margin-bottom: 15px;"/>
                        </div>
                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                            <h5 style="margin-bottom: 2px;">Dirección del Receptor</h5>
                            <InputText type="text" v-model="this.destination.address" placeholder="Dirección"  style="margin-bottom: 15px;"/>
                        </div>
                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                            <h5 style="margin-bottom: 2px;">Motivo de traslado</h5>
                            <InputText type="text" v-model="this.destination.reason" placeholder="Motivo"  style="margin-bottom: 15px;"/>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Agregar" class="p-button-success mr-2 mb-2" @click="onAddDestination"/>
                    </template>
                </Dialog>
			</div>
		</div>
    </div>
</template>

<script>

import { saveDownload } from '../../service/fileDownload';
import { authorizedXmlNotice } from '../../service/authorizedXml';
import httpRequest from '../../service/httpRequest';
import Sale from '../../models/sale';
import Proforma from '../../models/proforma';
import Product from '../../models/product';
import RemisionGuide, { OBSERVATIONS_MAX_LENGTH } from '../../models/remisionGuide';
import RemisionGuideItem from '../../models/remisionGuideItem';
import RemisionGuideDestination from '../../models/remisionGuideDestination';
import ObservationsField from '../../components/General/ObservationsField.vue';
import Business from '../../models/business';
import EventBus from '@/AppEventBus';
import { showSriPendingToast, clearSriPendingToast } from '@/service/sriPendingToast';
import { certificateError } from '@/service/certificateError';

export default {
    components: {
        'ObservationsField': ObservationsField,
    },
    computed: {
        // Sin credenciales del portal no se le puede informar la anulacion al SRI.
        hasSriCredentials() {
            const business = this.$store.getters.business;
            return !!(business && business.hasSriPortalCredentials);
        },
        // Cargarlas vive en Negocio, que es pantalla de administrador.
        canEditBusiness() {
            return this.$can('business');
        },
        // Ya anulada aca sin avisarle al SRI: decide la variante del aviso de
        // credenciales (sin "Anular sin reportar", que volveria a anular).
        annulmentUnreported() {
            return !!(this.guide && this.guide.edoc && this.guide.edoc.annulmentUnreported);
        },
        // Paso el plazo del SRI para anular (ver models/edocument.js): el aviso de
        // anular frena antes de confirmar.
        annulmentExpired() {
            return !!(this.guide && this.guide.edoc && this.guide.edoc.annulmentExpired);
        },
        observationsMaxLength() {
            return OBSERVATIONS_MAX_LENGTH;
        },
    },
	data() {
		return {
            guide: new RemisionGuide(),
            sale: new Sale(),
            guideItem: new RemisionGuideItem(),
            destination: new RemisionGuideDestination(),
            destinationSuggestions: [],
            courrier: {name: "", id: null, vehicleId: null},
            courrierSuggestions: [],
            searchedProduct: null,
            productOptions: [],
            selectedProduct: null,
            documentType: "",

            // Show
            // showNewButton: false,
            showProductDialog: false,
            showDestinationDialog: false,
            showSubscriptionDialog: false,
            showClearButton: false,
            showSaveButton: false,
            showCreateEDOCButton: false,
            showDeleteButton: false,
            showDeleteguideConfirmation: false,

            // Anulacion ante el SRI (mismo flujo que la factura). Mientras dura
            // bloquea el boton del aviso; el desenlace llega por WebSocket.
            annulmentInProgress: false,
            showSriCredentialsDialog: false,
            showAnnulmentOutcome: false,
            annulmentOutcome: null,
            showDownloadGuideButton: false,

            // Errors
            cardBackgroundColor: 'white',
            productError: false,
            destinationError: false,
            courrierIdentificationError: false,
            courrierNameError: false,
            vehicleIdentificationError: false,
            departureAddressError: false,
            startDeliveryDateError: false,
            endDeliveryDateError: false,
            error: {},

            // Loading
            loadingSaveButton: false,
            loadingCreateEDOCButton: false,
            loadingDeleteButton: false,
            loadingDownloadButton: false,
            loadingDownloadGuideButton: false,

            // Download
            downloadOptions: [
                {
                    label: 'PDF',
                    name: 'pdf',
                    icon: 'pi pi-file-pdf'
                },
                {
                    label: 'XML',
                    name: 'xml',
                    icon: 'pi pi-file-excel'
                },
            ],
		}
	},
    async created() {
        window.scrollTo(0, 0);

        // Desenlace de la anulacion ante el SRI (ver onAnnulmentResult)
        EventBus.on('annulment_result', this.onAnnulmentResult);

        // Get params
        let guideId = this.$route.query.id;
        let saleId = this.$route.query.saleId;
        let proformaId = this.$route.query.proformaId;

        if (guideId !== null && guideId !== undefined) {
            // Get guide
            let response = await httpRequest.getGuide(guideId);
            if (response.status == 200) {
                this.documentType = "Factura";
                this.sale = new Sale(response.data.sale);
                this.guide = new RemisionGuide(response.data);
                this.courrier = {name: this.guide.courrierName, id: this.guide.courrierIdentification, vehicleId: this.guide.vehicleIdentification};
                this.setupUI();
            }
        } else if (saleId !== null && saleId !== undefined) {
            // Get sale 
            this.documentType = "Factura";
            let response = await httpRequest.getSale(saleId);
            if (response.status == 200) {
                this.sale = new Sale(response.data);
                this.parseItems(this.sale.items);
                this.setupUI();
            }
        } else if (this.$route.query.proformaId !== undefined) {
            // Get proforma
            this.documentType = "Proforma";
            let response = await httpRequest.getProforma(proformaId);
            if (response.status == 200) {
                this.sale = new Proforma(response.data);
                this.parseItems(this.sale.items);
                this.setupUI();
            }
        } else { this.setupUI(); }
    },
    beforeUnmount() {
        EventBus.off('annulment_result', this.onAnnulmentResult);
        clearSriPendingToast(this.$toast);
    },
	methods: {
        setupUI() {
            this.showNewButton = this.guide.id !== null;
            this.showClearButton = this.guide.id === null;
            const edoc = this.guide.edoc;
            this.showDownloadGuideButton = this.guide.id !== null && edoc !== null && edoc.nulled === false;
            // Con una solicitud de anulacion en curso, pedir otra la duplicaria.
            this.showDeleteButton = this.showDownloadGuideButton && !edoc.annulmentInFlight;
            this.showSaveButton = this.guide.id === null;
            this.showCreateEDOCButton = this.guide.id !== null && this.guide.edoc === null;
            this.cardBackgroundColor = (this.guide.edoc !== null && this.guide.edoc.nulled === true) ? "#ffc9c9" : "white";
        },
        parseItems(data) {
            var items = [];
            for (var index in data) {
                items.push({id: data[index].productId, amount: data[index].amount, description: data[index].product}) }
            this.guide.items = items.map(item => new RemisionGuideItem(item));
        },
        async onProductFilterChanged(event) {
            let filter = event.query;
            if (filter.length > 1) {
                const result = await httpRequest.getProducts(filter);
                if (result.status === 200) {
                    this.productOptions = result.data.map(product => new Product(product));
                } else { this.productOptions = [] }
            }
        },
        onProductSelected(data) {
            let product = new Product(data.data);
            let object = {
                id: product.id,
                description: product.name,
                amount: 1
            }
            
            this.guide.addItem(new RemisionGuideItem(object));
            
            this.selectedProduct = null;
            this.showProductDialog = false;
            this.productError = false;
        },

        // Courrier
        checkForm() {
            var error = null;
            
            this.productError = false;
            this.destinationError = false;
            this.courrierNameError = false;
            this.courrierIdentificationError = false;
            this.vehicleIdentificationError = false;
            this.departureAddressError = false;
            this.startDeliveryDateError = false;
            this.endDeliveryDateError = false;

            if (this.guide.items === null || this.guide.items.length === 0) {
				this.productError = true;
                if (error === null) { error = "Ingrese al menos un producto" }
			}

            if (this.guide.destinations === null || this.guide.destinations.length === 0) {
				this.destinationError = true;
                if (error === null) { error = "Ingrese al menos un destino" }   // el mismo texto del aviso rojo (H34)
			}

			if (this.courrier.name === null || this.courrier.name === undefined || this.courrier.name === "") {
				this.courrierNameError = true;
                if (error === null) { error = "Ingrese el nombre completo del transportista" }
			}

            if (this.courrier.id === null || this.courrier.id === undefined || this.courrier.id === "" || this.courrier.id.length != 10) {
				this.courrierIdentificationError = true;
                if (error === null) { error = "Ingrese la cédula del transportista, debe contener 10 digitos" }
			}

            if (this.courrier.vehicleId === null || this.courrier.vehicleId === undefined || this.courrier.vehicleId === "") {
				this.vehicleIdentificationError = true;
                if (error === null) { error = "Ingrese la placa del vehículo" }
			}

            if (this.guide.departureAddress === null || this.guide.departureAddress === undefined || this.guide.departureAddress === "") {
				this.departureAddressError = true;
                if (error === null) { error = "Ingrese la dirección de salida" }
			}

            if (this.guide.startDeliveryDate === null || this.guide.startDeliveryDate === undefined || this.guide.startDeliveryDate === "") {
				this.startDeliveryDateError = true;
                if (error === null) { error = "Ingrese la fecha de salida" }
			}

            if (this.guide.endDeliveryDate === null || this.guide.endDeliveryDate === undefined || this.guide.endDeliveryDate === "") {
				this.endDeliveryDateError = true;
                if (error === null) { error = "Ingrese la fecha de llegada" }                
			}

			return error;
		},
        onResetFieldError(sender) {
            if (sender.target.id === "courrierName") { this.courrierNameError = false }
            else if (sender.target.id === "courrierId") { this.courrierIdentificationError = false }
            else if (sender.target.id === "vehicleId") { this.vehicleIdentificationError = false }
            else if (sender.target.id === "departureAddress") { this.departureAddressError = false }
            else if (sender.target.id === "startDeliveryDate") { this.startDeliveryDateError = false }
            else if (sender.target.id === "endDeliveryDate") { this.endDeliveryDateError = false }
        },
        async searchCourrier(event) {
            const query = event.query.trim();
            this.courrier = {name: event.query, id: null, vehicleId: null}

            if (!query.length) {
                this.courrierSuggestions = [];
            } else {
                let response = await httpRequest.searchGuideCourrier(query.toLowerCase());
                if (response.status === 200 && response.data !== undefined && response.data !== null) {
                    this.courrierSuggestions = [];
                    response.data.map(d => { this.courrierSuggestions.push({name: d.name, id: d.id, vehicleId: d.vehicleId}) })
                } else {
                    this.$toast.add({severity:'error', summary: 'Error', detail: "Error realizando busqueda", life: 3000});
                }
            }
        },

        // Product
        displayProductDialog() {
            this.showProductDialog = true;
        },
        onAddProduct() {
            this.guide.addItem(new RemisionGuideItem(this.guideItem));
            this.guideItem = new RemisionGuideItem();
            this.showProductDialog = false;
            this.productError = false;
            
        },
        onItemChanged(data) {
            this.guide.addItem(data)
        },
        onItemDeleted(item) {
            this.guide.deleteItem(item.data);
        },

        // Destination
        displayDestinationDialog() {
            this.showDestinationDialog = true;
        },
        onAddDestination() {
            const error = this.destination.isComplete();
            if (error !== null) {
                this.$toast.add({severity:'error', summary: 'Formulario incompleto', detail: error, life: 5000});
            } else {    
                this.guide.addDestination(new RemisionGuideDestination(this.destination));
                this.destination = new RemisionGuideDestination();
                this.showDestinationDialog = false;
                this.destinationError = false;
            }
        },
        onEditDestination(destination) {
            this.destination = destination.data;
            this.showDestinationDialog = true;
        },
        onDestintationDeleted(destination) {
            this.guide.deleteDestination(destination.data);
        },
        async searchDestination(event) {
            this.destination = new RemisionGuideDestination()
            this.destination.receiverName = event.query;

            const query = event.query.trim();
            if (!query.length) {
                this.destinationSuggestions = [];
            } else {
                let response = await httpRequest.searchGuideDestination(query.toLowerCase());
                if (response.status === 200 && response.data !== undefined && response.data !== null) {
                    this.destinationSuggestions = [];
                    response.data.map(d => { this.destinationSuggestions.push(new RemisionGuideDestination(d)) })
                } else {
                    this.$toast.add({severity:'error', summary: 'Error', detail: "Error realizando busqueda", life: 3000});
                }
            }
        },

        // Remision guide
        toggleDownloadMenu(event) {
            this.$refs.menu.toggle(event);
        },
        onClearFields() {
            this.guide = new RemisionGuide();
        },
        closeSubscriptionDialog() {
            this.showSubscriptionDialog = false;
        },
        redirectToSubscription() {
            this.showSubscriptionDialog = false;
            this.$router.push('/dashboard/general/suscripcion');
        },
        async saveGuide() {
            const error = this.checkForm();
            if (error !== null) {
                this.$toast.add({severity:'error', summary: 'Formulario incompleto', detail: error, life: 5000});
            } else {
                // Enable loading mode
                this.loadingSaveButton = true;

                // Attaching courrier to guide data
                this.guide.courrierName = this.courrier.name;
                this.guide.courrierIdentification = this.courrier.id;
                this.guide.vehicleIdentification = this.courrier.vehicleId;

                // Send request
                if (this.documentType === "Factura") {this.guide.saleId = this.sale.id}
                let response = await httpRequest.saveGuide(this.guide);

                // Disable loading mode
                this.loadingSaveButton = false;

                if (response.data !== undefined && response.data !== null) {
                    this.guide = new RemisionGuide(response.data);
                }

                if (response.status === 200) {
                    history.pushState(
                        {},
                        null,
                        this.$route.path + '?id=' + this.guide.id + '&saleId=' + this.sale.id
                    )
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su guía de remisión ha sido generada y reportada al SRI.', life: 3000});
                } else if (response.status === 602 || response.status === 604) {
                    // La firma o una dirección que el SRI exige no dejan emitir: la guía quedó guardada.
                    this.$toast.add({severity:'warn', summary: 'Guía guardada sin emitir', detail: certificateError(response, false).mensaje, life: 12000});
                } else if (response.status === 802) { 
                    this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                    this.error.mensaje = "Su guía de remisión ha sido guardada por el momento. Para reportar su guía al SRI por favor renueve su suscripción."
                    this.showSubscriptionDialog = true;
                    
                } else {
                    this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
                }

                this.setupUI()
            }
        },
        async attemptToCreateRemisionGuide() {
            // Enable loading mode
            this.loadingCreateEDOCButton = true;

            // Send request
            let response = await httpRequest.attemptToCreateRemisionGuide(this.guide.id, this.sale.id);

            // Disable loading mode
            this.loadingCreateEDOCButton = false;

            if (response.data !== undefined && response.data !== null) {
                this.guide = new RemisionGuide(response.data);
            }

            if (response.status === 200) {
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.guide.id + '&saleId=' + this.sale.id
                )
                this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su guía de remisión ha sido generada y reportada al SRI.', life: 3000});
            } else if (response.status === 602 || response.status === 604) {
                // La firma o una dirección que el SRI exige no dejan emitir: la guía quedó guardada.
                this.$toast.add({severity:'warn', summary: 'Guía guardada sin emitir', detail: certificateError(response, false).mensaje, life: 12000});
            } else if (response.status === 802) { 
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Su guía de remisión ha sido guardada por el momento. Para reportar su guía al SRI por favor renueve su suscripción."
                this.showSubscriptionDialog = true;
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }

            this.setupUI();
        },
        async deleteGuide(reportToSri = true) {
            // Autorizada y sin credenciales del portal: no hay forma de informarle la
            // anulacion al SRI. Se pregunta antes (ver saleForm.vue).
            const edoc = this.guide.edoc;
            if (reportToSri && edoc && edoc.authorized && !(await this.refreshSriCredentials())) {
                this.showDeleteguideConfirmation = false;
                this.showSriCredentialsDialog = true;
                return;
            }

            this.showSriCredentialsDialog = false;
            this.loadingDeleteButton = true;
            let response = await httpRequest.deleteGuide(this.guide.id, reportToSri);
            this.showDeleteguideConfirmation = this.loadingDeleteButton = false;
            if (response.status === 200) {
                // Autorizada: se le pidio la anulacion al SRI y el desenlace llega por
                // WebSocket. Nada se da por anulado todavia.
                if (response.data !== null && response.data.async === true) {
                    this.annulmentInProgress = true;
                    showSriPendingToast(this.$toast, {summary: 'Anulación en curso', detail: response.data.message,
                        onTimeout: () => { this.annulmentInProgress = false; }});
                    await this.reloadGuide();
                    return;
                }
                this.guide = new RemisionGuide(response.data);
                this.setupUI();
                const detail = this.guide.edoc && this.guide.edoc.annulmentUnreported
                    ? 'La guía quedó anulada en Contablus. Para el SRI sigue vigente hasta que la anules en el portal.'
                    : 'Su guía de remisión ha sido anulada.';
                this.$toast.add({severity:'success', summary: 'Guía anulada', detail: detail, life: 8000});
            } else if (response.status === 422 && response.error) {
                this.$toast.add({severity:'warn', summary: 'No se puede anular', detail: response.error, life: 10000});
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }
        },
        async reloadGuide() {
            let response = await httpRequest.getGuide(this.guide.id);
            if (response.status == 200) {
                this.sale = new Sale(response.data.sale);
                this.guide = new RemisionGuide(response.data);
                this.setupUI();
            }
        },
        // Una sola accion, la que el aviso declare (ver models/edocument.js).
        onAnnulmentAction(name) {
            if (name === 'report') { return this.reportAnnulmentToSri() }
            if (name === 'check') { return this.checkAnnulmentStatus() }
        },
        // Informa al SRI una anulacion que quedo solo en Contablus.
        async reportAnnulmentToSri() {
            if (!this.guide.edoc) { return }
            if (!(await this.refreshSriCredentials())) { this.showSriCredentialsDialog = true; return }
            this.annulmentInProgress = true;
            let response = await httpRequest.reportAnnulmentToSri(this.guide.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Reportando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            this.$toast.add({severity:'error', summary: 'No se pudo reportar',
                detail: response.error || 'Intenta de nuevo en un momento.', life: 10000});
        },
        async checkAnnulmentStatus() {
            if (!this.guide.edoc) { return }
            this.annulmentInProgress = true;
            let response = await httpRequest.checkAnnulmentStatus(this.guide.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Consultando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            if (response.status === 200) {
                await this.reloadGuide();
                this.setAnnulmentOutcome('Estado actualizado', 'pi-info-circle', 'blue',
                    (this.guide.edoc && this.guide.edoc.annulmentMessage) || 'El comprobante ya no tiene una anulación en curso.');
            } else if (response.status === 422 && response.error) {
                const missingCredentials = !!(response.data && response.data.reason === 'sriCredentialsMissing');
                this.setAnnulmentOutcome('Consulta al SRI', 'pi-info-circle', 'blue', response.error,
                    missingCredentials ? 'sriCredentials' : null);
            } else {
                this.$toast.add({severity:'error', summary: 'No se pudo consultar',
                    detail: response.error || 'Intenta de nuevo en un momento.', life: 8000});
            }
        },
        // El store NO se rehidrata entre pestañas (ver saleForm.vue): antes de
        // frenar por falta de credenciales se le pregunta al backend.
        async refreshSriCredentials() {
            if (this.hasSriCredentials) { return true }
            const response = await httpRequest.syncAccount();
            if (response.status === 200 && response.data && response.data.business) {
                await this.$store.dispatch('setBusiness', new Business(response.data.business));
            }
            return this.hasSriCredentials;
        },
        goToSriCredentials() {
            window.open('/dashboard/general/informacion-basica?focus=sri-portal', '_blank');
            this.showSriCredentialsDialog = false;
            this.showAnnulmentOutcome = false;
        },
        // `action` (opcional) agrega un boton al dialogo; hoy solo 'sriCredentials'.
        setAnnulmentOutcome(title, icon, color, message, action = null) {
            this.annulmentOutcome = {title, icon, color, message, action};
            this.showAnnulmentOutcome = true;
        },
        // Desenlace por WebSocket. Como la factura, lo normal es 'accepted' en el
        // acto; si el portal respondiera otra cosa, el barrido lo resuelve.
        async onAnnulmentResult(data) {
            if (!data || !this.guide || !this.guide.edoc) { return }
            if (data.edocId !== this.guide.edoc.id) { return }
            clearSriPendingToast(this.$toast);

            this.annulmentInProgress = false;
            if (data.status !== 'ok') {
                this.setAnnulmentOutcome('No se pudo anular', 'pi-times-circle', 'red', data.message);
            } else if (data.state === 'accepted') {
                this.setAnnulmentOutcome('Comprobante anulado', 'pi-check-circle', 'green', data.message);
            } else {
                this.setAnnulmentOutcome('Solicitud enviada', 'pi-clock', 'orange', data.message);
            }
            await this.reloadGuide();
        },
        async downloadGuide(type) {
            if (type === 'pdf') {
                this.loadingDownloadGuideButton = true;
                try {
                    const response = await httpRequest.downloadGuide(this.guide.id, type);
                    await saveDownload(response, "guia_remision_" + this.guide.edoc.serial + ".pdf", "application/pdf", this.$toast);
                } finally {
                    this.loadingDownloadGuideButton = false;
                }
            } else if (type === 'xml') {
                this.loadingDownloadGuideButton = true;
                try {
                    const response = await httpRequest.downloadGuide(this.guide.id, type);
                    if (await saveDownload(response, "guia_remision_" + this.guide.edoc.serial + ".xml", "application/xml", this.$toast)) {
                        const notice = await authorizedXmlNotice(response);
                        if (notice) this.$toast.add(notice);
                    }
                } finally {
                    this.loadingDownloadGuideButton = false;
                }
            }
        },
        displayDeleteguideConfirmation(show) {
            this.showDeleteguideConfirmation = show;
        },
    }
}
</script>

<style scoped lang="scss">
    // Boton de accion del aviso de anulacion: toma el color del aviso (ver purchaseForm.vue).
    .annulmentNoticeAction {
        width: auto;
        background: transparent;
        color: var(--notice-accent-strong);
        border: 1px solid var(--notice-accent);
        font-weight: 600;
    }
    .annulmentNoticeAction:enabled:hover,
    .annulmentNoticeAction:enabled:focus {
        background: var(--notice-accent);
        border-color: var(--notice-accent);
        color: #fff;
        box-shadow: none;
    }
    .menuButton {
        width: 100%;
        background-color: white;
        border: 0px;
        color: darkgrey;
    }
    .menuButton:hover {
        background-color: gray;
    }

    @media screen and (max-width: 769px) {
        .number-textfield {
            width: 150px;
            height: 30px;
            font-size: 13px;;
        }
        .guideReceiptContainer {
            width: 100%; 
            display: block;
        }
        .receiptContainer {
            width: 100%;
            margin-right: 0px;
        }
        .receiptSerialContainer {
            width: 100%;
        }
        .saleFormButtonContainer {
            display: block;
        }
        .paymentContainer {
            display: initial;
        }
        .paymentContainer > div > h5 {
            margin: 10px 0 5px 0; 
        }
        .paymentSubcontainer {
            display: block;
        }
        .collectButton {
            margin-top: 10px;
            padding: 0px;
            width: 100%;
        }
        .customButton {
            width: 100%;
        }
    }
    @media screen and (min-width: 769px) {
        .number-textfield {
            margin: 0px 0px 10px auto;
            width: 100px;
            height: 30px;
            font-size: 15px;

        }
        .guideReceiptContainer {
            width: 100%; 
            display: flex;
        }
        .receiptContainer {
            width: 60%;
            margin-right: 20px;
        }
        .receiptSerialContainer {
            width: 40%;
        }
        .saleFormButtonContainer {
            display: flex;
        }
        .saleInformationContainer {
            padding-left: 50px;
        }
        .paymentContainer {
            display: flex;
            // height: 6rem;
        }
        .paymentContainer > div > h5 {
            margin-bottom: 5px; 
        }
        .paymentSubcontainer {
            display: flex;
        }
        .collectButton {
            margin-left: 10px;
        }
        .customButton {
            width: auto;
        }
    }

    ::v-deep(.p-autocomplete) {
    position: relative;
}

    ::v-deep(.p-autocomplete-panel) {
        min-width: 100% !important;
        width: 100% !important;
        left: 0 !important;
        right: auto !important;
        box-sizing: border-box;
        max-width: 100vw;
    }
</style>